// Shared helpers for Supabase pagination (`.range()` is inclusive on both ends).

// Row bounds of a 0-based page, ready for `query.range(from, to)`.
export function pageRange(pageIndex: number, pageSize: number) {
  const from = pageIndex * pageSize;
  return { from, to: from + pageSize - 1 };
}

// `getNextPageParam` for `useInfiniteQuery` with 0-based page indexes: a short
// page means the server has nothing left.
export function getNextPageIndex(pageSize: number) {
  return function nextPageIndex(lastPage: unknown[], allPages: unknown[][]) {
    return lastPage.length < pageSize ? undefined : allPages.length;
  };
}

// Merges `useInfiniteQuery` pages, dropping rows already seen. Offset pages
// shift when rows are inserted or reordered between two fetches, so the next
// page can repeat the tail of the previous one (duplicate React keys).
export function flattenUniquePages<T>(pages: T[][] | undefined, getKey: (item: T) => string): T[] {
  const seen = new Set<string>();
  const items: T[] = [];

  for (const item of pages?.flat() ?? []) {
    const key = getKey(item);
    if (!seen.has(key)) {
      seen.add(key);
      items.push(item);
    }
  }

  return items;
}

// Default `getKey` for `flattenUniquePages` on table rows.
export function getId(item: { id: string }) {
  return item.id;
}
